import { ADDITIONAL_SERVICES_FEATURE } from '../reducers/index';
import { createFeatureSelector } from '@ngrx/store';
import * as fromAdditionalServices from '../reducers';

export const getAdditionalServicesState =
  createFeatureSelector<fromAdditionalServices.AdditionalServicesState>(
    ADDITIONAL_SERVICES_FEATURE
  );
